export class RelatorioSistemaModel {
    constructor(
        public sistema: string = '',
        public ativos: number = 0,
        public inativos: number = 0
    ) { }
}